module.exports = __webpack_public_path__ + "static/image/history/pc/201006@3x.ver2_0_2.jpg?fac763b8";